import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsAllPlanWorks(companyId, regulationId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_ALL_PLAN_WORKS,dtConfig[ModulesMap.REGULATIONS_ALL_PLAN_WORKS].getRegulationsAllPlanWorks,
		{
			urlParams: {
				companyId,
				regulationId,
			},
		},
	)
}
export default {
	getRegulationsAllPlanWorks,
}